<template>
    <v-card class="defaultCard" color="bgtopology" elevation="0">
        <span class="titlePages">{{ t('adminPage.titleCSVview') }}</span>
        <v-file-input 
        v-model="rajant"
        clearable 
        label="MESH" 
        density="compact"
        variant="outlined"
        @change="handleFileRajantUpload" 
        @click:clear="clearData('rajant')"
        class="mt-5"
        append-icon="mdi-tooltip-question-outline"
        @click:append="showDialog('rajant')"
        :error="errorRajant"
        >
        </v-file-input>
        <v-file-input 
        v-model="cambium"
        class="mt-5" 
        clearable 
        label="PMP" 
        density="compact"
        variant="outlined"
        @change="handleFileCambiumUpload" 
        @click:clear="clearData('cambium')"
        append-icon="mdi-tooltip-question-outline"
        @click:append="showDialog('cambium')"
        :error="errorCambium"
        >
        </v-file-input>
        <v-row class="mt-5 mb-3">
            <v-col cols="6">
                <v-btn 
                :disabled="fileItemRajant.length === 0"
                block
                color="bgCircular"
                @click="rajantEvent"
                >
                    MESH
                </v-btn>
            </v-col>
            <v-col cols="6">
                <v-btn                 
                :disabled="fileItemCambium.length === 0"
                block
                color="bgCircular"
                @click="cambiumEvent"
                >
                    PMP
                </v-btn>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackbar" >
            {{ t('adminPage.titleSnak') }}
            <template v-slot:actions>
                <v-btn
                color="pink"
                variant="text"
                @click="snackbar = false"
                >
                    {{ t('adminPage.closeBtn') }}
                </v-btn>
            </template>
        </v-snackbar>
        
    </v-card>

    <v-dialog v-model="dialog" width="50%">
        <v-row>
          <v-col v-if="typeIMG === 'rajant'" cols="12">
            <v-sheet color="bgtopology rounded" class="pa-5">
              <h2>Formato del archivo Rajant</h2>
              <v-img src="@/assets/rajant.png"></v-img>
            </v-sheet>
          </v-col>
          <v-col v-if="typeIMG === 'cambium'" cols="12">
            <v-sheet color="bgtopology rounded" class="pa-5">
              <h2>Formato del archivo Cambium</h2>
              <v-img src="@/assets/cambium.png"></v-img>
            </v-sheet>
          </v-col>
        </v-row>
    </v-dialog>
</template>

<script setup lang="ts">
import { ref, onMounted, Ref } from 'vue';
import { read, utils }  from 'xlsx';
import axios            from 'axios';
import { useI18n }      from 'vue-i18n';

// CONSTANTS
import CONSTAPIS, { TIMEOUTTIME }        from '@/constants/apis';

// INTERFACES
import { GENERAL_EQUIPAMENT, IP_EQUIPAMENT } from '@/interfaces/SmartLink/Equips';
import { TOKEN } from '@/constants/labels';

interface NewEquipment {
  ip: string;
  tag: string;
  marca: string;
  rol: string;
  tipo: string;
  snmp_conf: number;
}


/**
 * Mostrar el Dialogo
 */
const dialog = ref(false);
const typeIMG = ref('');


function showDialog(type:string){
  dialog.value = true
    if(type === 'rajant') typeIMG.value = 'rajant'
    if(type === 'cambium') typeIMG.value = 'cambium'

}

const { t }                                             = useI18n()
const rajant                                            = ref();
const cambium                                           = ref();
const fileItemRajant:Ref<GENERAL_EQUIPAMENT[]>          = ref([]);
const fileItemNameRajant:Ref<GENERAL_EQUIPAMENT[]>      = ref([]);
const fileItemCambium:Ref<GENERAL_EQUIPAMENT[]>         = ref([]);
const fileItemNameCambium:Ref<GENERAL_EQUIPAMENT[]>     = ref([]);
const fileItemInsertRajant:Ref<GENERAL_EQUIPAMENT[]>    = ref([]);
const fileItemInsertCambium:Ref<GENERAL_EQUIPAMENT[]>   = ref([]);
const snackbar                                          = ref(false);
const allEquipment:Ref<IP_EQUIPAMENT[]>                 = ref([]);

const errorRajant = ref(false);
const errorCambium = ref(false);
const handleFileRajantUpload = async (event: any) => {
  // 1. Gestión inicial del archivo
  const file = event.target.files?.[0];
  errorRajant.value = false;
  
  // Limpiamos todos los arrays de resultados para evitar duplicados
  fileItemRajant.value = [];
  fileItemNameRajant.value = [];
  fileItemInsertRajant.value = [];

  if (!file) return;

  try {
    const buffer = await file.arrayBuffer();
    const workbook = read(buffer, { type: 'array' });
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = utils.sheet_to_json(worksheet, { header: 1 }) as any[][];

    // 2. Regex para validar formato IPv4
    const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

    // 3. Optimización: Indexamos equipos actuales en Sets para búsqueda instantánea O(1)
    const existingIps = new Set(allEquipment.value.map((e: IP_EQUIPAMENT) => e.ip?.trim()));
    const existingNames = new Set(allEquipment.value.map((e: IP_EQUIPAMENT) => e.name?.trim()));

    jsonData.forEach((elem) => {
      const rawIp = elem[2]?.toString().trim() || '';
      
      // VALIDACIÓN: ¿Es una IP válida? (ya no importa si empieza por 10 o no)
      if (ipRegex.test(rawIp)) {
        const ipfinal = rawIp;
        const tag     = elem[1]?.toString().trim() || 'Sin Nombre';
        const tipo    = elem[6]?.toString().trim() || 'Desconocido';

        const isMatchIp   = existingIps.has(ipfinal);
        const isMatchName = existingNames.has(tag);

        // Lógica de clasificación
        if (isMatchIp) {
          // Caso A: La IP ya existe en la base de datos
          fileItemRajant.value.push({ ip: ipfinal, tag });
        } 
        else if (isMatchName) {
          // Caso B: El nombre existe pero con otra IP (Posible reasignación)
          fileItemNameRajant.value.push({ ip: ipfinal, tag, tipo });
        } 
        else {
          // Caso C: No existe ni IP ni Nombre (Equipo totalmente nuevo)
          fileItemInsertRajant.value.push({
            ip: ipfinal,
            tag: tag,
            marca: 'Rajant',
            rol: 'Cliente',
            tipo: tipo, 
            snmp_config: ''
          });
        }
      }
    });

    // 4. Feedback final
    if (fileItemRajant.value.length === 0 && 
        fileItemInsertRajant.value.length === 0 && 
        fileItemNameRajant.value.length === 0) {
      snackbar.value = true;
      errorRajant.value = true;
    }

  } catch (err) {
    console.error("Error al procesar el Excel:", err);
    errorRajant.value = true;
  }
};

const handleFileCambiumUpload = (event:any) => {

  errorCambium.value = false;
    
    if(event.target.files[0] !== undefined){
        fileItemCambium.value = [];

        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e:any) => {

            const data      = new Uint8Array(e.target.result);
            const workbook  = read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData  = utils.sheet_to_json(worksheet, { header: 1 });

            jsonData.forEach((elem:any) => {

                if(elem[5]?.split('.')[0] === '10' && typeof elem[5] === 'string' && elem[5] !== ''){

                    let ipfinal     = elem[5];
                    let tag    = elem[4];
                    let tipo      = elem[7];
                    let isMatch     = false;
                    let isMatchName = false;

                    allEquipment.value.find(({ip,name}:IP_EQUIPAMENT)=>{
                        if(ip == ipfinal){
                            isMatch = true;
                        }
                        if(name == tag){
                            isMatchName = true;
                        }
                    })

                    if(isMatch){
                        let objFile = {
                            ip          :   ipfinal,
                            tag    :   tag,
                            tipo        :   tipo
                        }
                        fileItemCambium.value.push(objFile);
                    } else{
                        if(isMatchName && !isMatch){
                            let objFileName = {
                                ip              :   ipfinal,
                                tag        :   tag,
                                tipo:   tipo
                            }
                            fileItemNameCambium.value.push(objFileName);
                        } else{
                            let objFile:any = {
                                elemid      :   0,
                                ip          :   ipfinal,
                                tag    :   tag,
                                // modelo      :   modelo,
                                // serial      :   serial,
                                // marca       :   'Cambium',
                                // tipo        :   modelo.split(' ').slice(-1) == 'SM' ? 'PMP' : 'PMP-AP',
                                // subtipo     :   'Distribucion',
                                // observacion :   ' ',
                                // ubicacion   :   ' ',
                                // padre       :   0,
                                // gpsLat      :   ' ',
                                // gpsLong     :   ' ',
                                gpsAlt      :   ' '
                            }
                            fileItemInsertCambium.value.push(objFile);
                        }
                    }

                    let objFile = {
                        ip          :   ipfinal,
                        tag    :   tag,
                        modelo      :   elem[7],
                        serial      :   elem[8]
                    }
                    fileItemCambium.value.push(objFile);
                }
            })

            if(fileItemCambium.value.length === 0) {
                errorCambium.value = true;
                snackbar.value = true;
            }
        };
        reader.readAsArrayBuffer(file);
    }else{
        fileItemCambium.value = [];
    }
}

const clearData = (type:string) => {
    if(type === 'rajant') fileItemRajant.value = []
    if(type === 'cambium') fileItemCambium.value = []
}


const rajantEvent = async () => {
    await axios.put(CONSTAPIS.APIS.value.csv.editDataInven,fileItemRajant.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            rajant.value                = [];
            fileItemRajant.value        = [];
        }                 
    })

    await axios.put(CONSTAPIS.APIS.value.csv.editDataByName,fileItemNameRajant.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            rajant.value                = [];
            fileItemNameRajant.value    = [];
        }                 
    })

    await axios.post(CONSTAPIS.APIS.value.csv.insertDataInven,fileItemInsertRajant.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            rajant.value                  = [];
            fileItemInsertRajant.value    = [];
        }                 
    })
}

const cambiumEvent = async () => {
    await axios.put(CONSTAPIS.APIS.value.csv.editDataInven,fileItemCambium.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            cambium.value               = [];
            fileItemCambium.value       = [];
        } 
    })

    await axios.put(CONSTAPIS.APIS.value.csv.editDataByName,fileItemNameCambium.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            cambium.value               = [];
            fileItemNameCambium.value   = [];
        } 
    })
    
    await axios.post(CONSTAPIS.APIS.value.csv.insertDataInven,fileItemInsertCambium.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            cambium.value               = [];
            fileItemInsertCambium.value = [];
        }                 
    })
}

onMounted(async() => {
    await axios.get(CONSTAPIS.APIS.value.csv.getDataInven, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((res)=>{
        allEquipment.value = res.data;
    })
})

</script>